// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterTrustLogos_root__xBvyL"};